import * as React from 'react';
import { flow } from 'lodash';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { Col, Modal, Button, FormGroup, Form } from 'react-bootstrap';
import { IChannel } from '../../../../../../data/api/models';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired, isValidPassword } from '../../../../../../util/validators';
import { IAuthState } from '../../../../../../services/auth/models';
import { connect } from 'react-redux';
import { IQuoteState } from '../../../../../../services/quote/models';
import { IStore } from '../../../../../../redux/IStore';
import FaPhone from 'react-icons/fa/phone';
import FaEnvelope from 'react-icons/fa/envelope';

interface ISaveQuoteFormProps {
  auth: IAuthState;
  quote: IQuoteState;
  password: string;
  passwordConfirmation: string;
  onGoToMyAccount: any;
  onCloseModal: any;
  handleSubmit: any;
  dispatch: any;
  change: any;
  channel: IChannel;
  isQuoteSaved: boolean;
  generalConditionsDocument?: string;
  renewal: boolean;
}

interface ISaveQuoteFormState {
  openModal: boolean;
}

class SaveQuoteForm extends React.Component<ISaveQuoteFormProps, ISaveQuoteFormState> {
  public render() {
    const {
      quote,
      channel,
      password,
      isQuoteSaved,
      onCloseModal,
      handleSubmit,
      onGoToMyAccount,
      passwordConfirmation,
      renewal,
    } = this.props;

    const customer = quote.customer;

    const customerStatus = customer && !!customer.length && customer[0].status;
    const isNewCustomer = customerStatus === 'new';
    const quoteReference = quote.application.quoteReference;
    const disableSaveQuote = isNewCustomer && !password && !passwordConfirmation && password !== passwordConfirmation;
    const NOT_APPLICABLE = 'not applicable';
    const divStyle = {color: '#000'};

    return(
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <Modal.Body>
          {!isQuoteSaved ? (
            <div style={divStyle}>
              {customerStatus === NOT_APPLICABLE && (
                <div>
                  <p className="margin-top">
                    To save your quote, you must create an account.
                  </p>
                  <p>
                    For security reasons, we invite you to configure your password respecting the following format:
                    Minimum of 10 characters in length containing at least one uppercase letter, one lowercase letter,
                    one digit and one special character ($ or ! for example)
                  </p>
                  <FormGroup>
                    <Col sm={12}  className="">
                      <div className="manual-field-label">
                        <strong>Password</strong>
                      </div>
                      <Field
                        name="password"
                        type="password"
                        placeholder="Password"
                        component={FieldFormControl}
                        validate={[isRequired, isValidPassword]}
                      />
                    </Col>
                    <Col sm={12} className="margin-top">
                      <div className="manual-field-label">
                        <strong>Confirm your Password</strong>
                      </div>
                      <Field
                        name="passwordConfirmation"
                        type="password"
                        placeholder="Confirm your Password"
                        component={FieldFormControl}
                        validate={[isRequired]}
                      />
                    </Col>
                  </FormGroup>
                </div>
              )}
              {customerStatus === 'pending' || customerStatus === 'new' && (
                <div>
                  <p>We noticed that you already have an account with us, we are delighted to see you again!</p>
                  <p>Your quote has been saved in your personal space.</p>
                  <h4>Reference: {quoteReference}</h4>
                  <p>You can access your account at any time to view your quote or documents.</p>
                </div>
              )}
              {customerStatus === 'active' && !isQuoteSaved && (
                <div>
                  <p>To save your quote in your personal area, click Save.</p>
                </div>
              )}
            </div>
          ) : (
            <div>
              {renewal ? (
                <div>
                  <p>Your renewal quote is saved. You can finalize it by connecting to your personal space.</p>
                </div>
              ) : (
                <div>
                  <h3>Your quote reference is <strong>{quoteReference}</strong></h3>
                  <br/>
                  <div>
                    <p>Thank you for requesting a quotation for your horsebox vehicles.</p>
                    <p>You can access your account at any time to retrieve the details of your quotation and/or make any
                      necessary changes to it.</p>
                  </div>
                </div>
              )}
              <p>Should you require any assistance with your quotation then please don't hesitate to contact us directly
                via:</p>
              <br/>
              <div id={'save-quote-contact-methods'}>
                <span className="phone">
                  <FaPhone/> {channel.phone}
                </span>
                <div className="opening-hours">
                  Mon-Fri 08:30 - 17:00, Sat 09:00 - 13:00
                </div>
                <br />
                <span>
                  <FaEnvelope/> <a href={`mailto:newbusiness@greenlands.co.uk`}>newbusiness@greenlands.co.uk</a>
                </span>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!isQuoteSaved ? (
            <div>
              <div>
                <Button
                  bsStyle="primary"
                  type="submit"
                  disabled={disableSaveQuote}
                >
                  Save
                </Button>
                <Button
                  bsStyle="primary"
                  onClick={onCloseModal}
                >
                  Cancel
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <Button
                bsStyle="primary"
                onClick={onGoToMyAccount}
              >
                My account
              </Button>
              <Button
                bsStyle="primary"
                onClick={onCloseModal}
              >
                Close
              </Button>
            </div>
          )}
        </Modal.Footer>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {passwordConfirmation: ''};
  if (values.passwordConfirmation !== values.password) {
    errors.passwordConfirmation = 'The password does not match the one previously entered, please enter it again';
  }
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'save_quote',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('save_quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const password = selector(state, 'password');
      const passwordConfirmation =  selector(state, 'passwordConfirmation');

      return {
        password,
        passwordConfirmation,
        auth: state.auth,
        quote: state.quote,
        channel: state.branding.channel,
      };
    },
  ),
])(SaveQuoteForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/SaveQuoteModal/components/SaveQuoteModalForm/index.tsx